export default __webpack_public_path__ + "static/media/pattern.c13f9c0d.png";